import React, { useEffect, useState } from "react";
import { Container, Row, Col, Modal, Button } from "react-bootstrap";
import googleImg from "./../../../Images/google-img.png";
import closeIcon from "./../../../Images/close-icon.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRupeeSign } from "@fortawesome/free-solid-svg-icons";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { faFacebook, faTwitter, faTelegram, faLinkedin, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import ReferralRewards from "../../../Images/referral-rewards.png";
import PendingReferral from "../../../Images/PendingReferral.png";
import ShareReferral from "../../../Images/ShareReferral.png";
import ArrowYou from "../../../Images/arrow-you.png";
import ArrowFriend from "../../../Images/arrow-friend.png";
import howreferearnStep1 from "../../../Images/howreferearn-step1.png";
import howreferearnStep2 from "../../../Images/howreferearn-step2.png";
import howreferearnStep3 from "../../../Images/howreferearn-step3.png";
import referearntrust from "../../../Images/referearntrust.png";
import referearnCloud from "../../../Images/referearnCloud.png";
import referearnSecure from "../../../Images/referearnSecure.png";
import "./ReferEarnNew.css";
import TrackApi from "../../Activity_Track/TrackApi";
import { useCookies } from "react-cookie";
import axios from 'axios';
import { ApiUrlDomain } from "../../Configration/Configrationnew";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown, faShare } from "@fortawesome/free-solid-svg-icons";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import avatar from "../../../Images/avatar.png";
import { FiCopy } from 'react-icons/fi'; // Feather Icons


function ReferEarnNew() {
    const requestIcon = <FontAwesomeIcon icon={faShare} />
    const rupee = <FontAwesomeIcon icon={faRupeeSign} />
    const Copy = <FontAwesomeIcon icon={faCopy} />
    const AngleRight = <FontAwesomeIcon icon={faAngleRight} />
    const ClosePopup = <FontAwesomeIcon icon={faTimes} />
    const ArrowRight = <FontAwesomeIcon icon={faArrowRight} />
    const Facebook = <FontAwesomeIcon icon={faFacebook} />;
    const Twitter = <FontAwesomeIcon icon={faTwitter} />;
    const Telegram = <FontAwesomeIcon icon={faTelegram} />;
    const Linkedin = <FontAwesomeIcon icon={faLinkedin} />;
    const Whatsapp = <FontAwesomeIcon icon={faWhatsapp} />;
    const Mail = <FontAwesomeIcon icon={faEnvelope} />;
    const [mobile, setmobile] = useState('');
    const [ShareReferPopup, setShareReferPopup] = useState(false);
    const [cookies, setCookie] = useCookies(['LeadId']);
    const [modelshow, setShow] = useState(false);
    const [referralCode, setReferralCode] = useState(''); // Store API response here
    const [loadingPage, setLoadingPage] = useState('');
    const [refferReward, setRefferReward] = useState('');
    const [pendingReffer, setpendingReffer] = useState('');
    const CloseCross = <FontAwesomeIcon icon={faClose} />;
    const ArrowCheck = <FontAwesomeIcon icon={faCheck} />;
    const AngleDown = <FontAwesomeIcon icon={faAngleDown} />;
    const AngleUp = <FontAwesomeIcon icon={faAngleUp} />;
    const [Pendingreferuserjorny, setPendingreferuserjorny] = useState(false);
    const [PendingReferPopup, setPendingReferPopup] = useState(false);
    const [copied, setCopied] = useState(false); // ✅ Add this line
    const [referralDetails, setReferralDetails] = useState([]);
    const [completedReffer, setCompletedReffer] = useState('');

    const handleClose = () => {
        setShow(false);
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    const ShowPendingUserJourney = (index) => {
        setPendingreferuserjorny(prevIndex => prevIndex === index ? null : index);
    };

    const ShowPendingpopup = (event) => {
        setPendingReferPopup(!PendingReferPopup);
        setShareReferPopup(false);
    }
   // const referralLink = `https://kyc.moneysukh.com/?Referred_by=${referralCode}`;
    const referralLink =  `${ApiUrlDomain}/userReferalSigUp/?Referred_by=${referralCode}`;
    
    console.log("sdhfgsdhf======",referralLink)
    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const clientCode = searchParams.get('ClientCode');
        console.log("clientCode:=", clientCode);

        if (clientCode) {
            setLoadingPage(clientCode);
            console.log('Extracted ClientCode (sAccountId):', clientCode);

            const sendToBackend = async () => {
                try {
                    const response = await axios.post(`${ApiUrlDomain}/userprofit`, {
                        sAccountId: clientCode,
                    });
                    console.log('sAccountId sent successfully:', response.data);
                    setReferralCode(response.data.referCode);
                    setRefferReward(response.data.refferReward);
                    setpendingReffer(response.data.pendingReffer);
                    setReferralDetails(response.data.details); // 👈 Set the details array here

                let completedCount = 0; // Track how many referrals are completed

                // Iterate through each user in the details array
                response.data.details.forEach(user => {
                    // Check if any of the user's getDetails meet the completion criteria
                    user.getDetails.forEach(element => {
                        if (
                            element.account_Opening_Started === 'Yes' &&
                            element.detail_Verification === 'Yes' &&
                            element.account_Successfully_Opened === 'Yes'
                        ) {
                            completedCount++; // Increment if the conditions are met
                        }
                    });
                });

                // Update the state with the completed referrals count
                setCompletedReffer(completedCount)
                console.log("Completed referrals count:", completedCount);
                } catch (error) {
                    console.error('Error sending sAccountId:', error);
                }
            };
            sendToBackend();
        } else {
            console.log('ClientCode not found in URL.');
        }
    }, []);

    const handlemobile = event => {
        const re = /^[0-9\b]+$/;
        if (event.target.value.length < 11 && re.test(event.target.value)) {
            setmobile(event.target.value);
        }
        if (event.target.value.length == 0) {
            setmobile("");
        }
    };

    const trackData = (id) => {
        const payloadData = {
            "RelatedProspectId": id,
            "ActivityNote": "Your home Note",
            "mx_Custom_1": "Refer Earn",
            "mx_Custom_2": "",
            "mx_CustomObject_81": window.location.href
        }
        TrackApi(payloadData);
    }

    const ShareReferLink = () => {
        setShareReferPopup(!ShareReferPopup);
        setPendingReferPopup(false);
    }
    const StophideShareReferpopup = (event) => {
        event.stopPropagation();
        setPendingReferPopup(false);
    }

    const ShowreReferpopup = (event) => {
        event.stopPropagation();
        setShow(true);
    }

    const handleCopy = () => {
        navigator.clipboard.writeText(referralLink)
            .then(() => {
                setCopied(true);
                setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
            })
            .catch(err => console.error('Failed to copy:', err));
    };

    useEffect(() => {

        if (cookies && cookies.RelatedProspectId) {
            trackData(cookies.RelatedProspectId);
        }

    }, [])

    const referralPlatforms = [
        {
            name: 'Facebook',
            iconClass: 'Refer-fb',
            icon: Facebook,
            onClick: () =>
                window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(referralLink)}`, '_blank')
        },
        {
            name: 'Twitter',
            iconClass: 'Refer-twitter',
            icon: Twitter,
            onClick: () =>
                window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(referralLink)}&text=Check%20this%20out!`, '_blank')
        },
        {
            name: 'Telegram',
            iconClass: 'Refer-telegram',
            icon: Telegram,
            onClick: () =>
                window.open(`https://t.me/share/url?url=${encodeURIComponent(referralLink)}&text=Join%20me%20on%20this%20platform!`, '_blank')
        },
        {
            name: 'LinkedIn',
            iconClass: 'Refer-linkedin',
            icon: Linkedin,
            onClick: () =>
                window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(referralLink)}&title=Join%20Us`, '_blank')
        },
        {
            name: 'WhatsApp',
            iconClass: 'Refer-whatsapp',
            icon: Whatsapp,
            onClick: () =>
                window.open(`https://api.whatsapp.com/send?text=Join%20me%20on%20this:%20${encodeURIComponent(referralLink)}`, '_blank')
        },
        {
            name: 'Mail',
            iconClass: 'Refer-mail',
            icon: Mail,
            onClick: () =>
                window.open(`https://mail.google.com/mail/?view=cm&fs=1&to=&su=Referral&body=Join%20me%20via%20this%20link:%20${encodeURIComponent(referralLink)}`, '_blank')

        },
        {
            name: 'Copy Link',
            iconClass: 'Refer-copy',
            icon: Copy,  // or whatever icon you imported
            onClick: () => {
                navigator.clipboard.writeText(referralLink).then(() => alert('Referral link copied!')).catch(err => console.error('Failed to copy link: ', err));
            }
        }
    ];

    return (
        <>
            <div className="ReferEarnNew-page">
                <div className="refer-bg ReferEarnNew-bg">
                    <section className="ReferEarnNew-section">
                        <Container>
                            <Row>
                                <Col xs={12}>
                                    <div className="section-header pb-5 ReferEarnNew_bnnrtop">
                                        <h2>Refer and Earn</h2>
                                        <p className="text-left">Refer Your Friends & Family and Earn <strong> ₹50</strong> per referral + upto
                                            <strong> 50%</strong> <br></br>Commission <small>(</small>Brokerage Sharing<small>)</small>*</p>
                                    </div>
                                </Col>
                            </Row>
                            {!loadingPage ? (
                                 <></>
                                // <div><h2> <p>Following the below steps</p></h2></div>
                            ) : (
                                <Row>
                                    <Col>
                                        <div className="referEarnNew-form">
                                            <h5 className="pb-3 align-left">Refer more! Earn more. No capping.</h5>
                                            <div className="input-group referearnnew_textcopy">
                                                <span className="form-control m-0 d-flex align-items-center" style={{ cursor: 'default' }}>
                                                    <i
                                                        style={{ cursor: 'pointer', marginRight: '8px' }}
                                                        onClick={handleCopy}
                                                        title="Copy referral link"
                                                    >
                                                        <FiCopy />
                                                    </i>
                                                    <span>{referralCode ? referralCode : 'Loading...'}</span>
                                                    {copied && <span style={{ marginLeft: '10px', color: 'green', fontWeight: '500' }}>✔ Copied!</span>}
                                                </span>
                                                <div onClick={() => ShareReferLink()} className="input-group-append">
                                                    <span className="btn"><i>{requestIcon}</i><strong>SHARE</strong></span>
                                                </div>

                                                {ShareReferPopup && (
                                                    <div className="ShareReferLink-Popup">
                                                        <span>Share Referral link on:</span>
                                                        <div className="ShareReferLink-icongrid">
                                                            <div onClick={StophideShareReferpopup} className="ShareReferLink-icongroup">
                                                                {referralPlatforms.map((platform, index) => (
                                                                    <span
                                                                        key={index}
                                                                        className={platform.iconClass}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation(); // Prevent hiding popup
                                                                            platform.onClick();
                                                                        }}
                                                                    >
                                                                        {platform.icon}
                                                                    </span>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="rewardreferrPndg-grid">
                                                <div className="rewardreferrPndg-group">
                                                    <div className="rewardreferrPndg-panel">
                                                        <span className="rewardreferrPndg-icon"><img src={ReferralRewards} alt="Referral Rewards" /></span>
                                                        <h4>Referral Rewards*</h4>
                                                        <div className="rewardsinvite-grid">
                                                            {refferReward ? refferReward : 0}
                                                        </div>
                                                    </div>
                                                    <div className="rewardreferrPndg-panel">
                                                        <span className="rewardreferrPndg-icon"><img src={PendingReferral} alt="Pending Referral" /></span>
                                                        <h4>Pending Referrals / Complete Referrals</h4>
                                                        <div className="rewardsinvite-grid">
                                                            {pendingReffer ? `${pendingReffer} Invites` : '0 Invites'}  /   {completedReffer ? `${completedReffer} Complete` : '0 Complete'}
                                                            <span onClick={() => ShowPendingpopup()} className="rewards-arrow">{AngleRight}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* .........................Pending-Refer-Popup-Start......................... */}
                                                {/* {PendingReferPopup &&
                                                    <div className="pendingrefer-popup">
                                                        <h4><span> Referrals Status</span></h4>
                                                        <p>Remind your friend to complete KYC and earn rewards</p>
                                                        <div className="pendingrefer-list">
                                                            <div className="pendingrefer-group">
                                                                <div className="pendingreferuser-list">
                                                                    <div className="pendingreferuser-repeat">
                                                                        <div className="pendingreferuser-group">
                                                                            <div className="pendingreferuser-grid">
                                                                                <div className="pendingreferuser-panel">
                                                                                    <img src={avatar} alt="ravindra-yadav"></img>
                                                                                </div>
                                                                                <div className="pendingreferuser-text">
                                                                                    <h5>{userName}</h5>
                                                                                    <div className="pendingreferuser-statusshare">
                                                                                        <div className="pendingreferuser-statuspanel">
                                                                                            <span className="pendingreferuser-completed">Completed</span>
                                                                                        </div>
                                                                                        <div className="pendingreferuser-share">
                                                                                            <a href="tel:1234561234"> <i>{Whatsapp}</i></a>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div onClick={() => ShowPendingUserJourney(3)} className="pendingreferuser-icon">
                                                                                {Pendingreferuserjorny ? AngleUp : AngleDown}
                                                                            </div>
                                                                        </div>
                                                                        {Pendingreferuserjorny &&
                                                                            <div className="pendingreferuserjourney-grid">
                                                                                <div className="pendingreferuserjourney-group">
                                                                                    <div className="pendingreferuserjourney-panel">
                                                                                        <i className="pndgreferusrjourney-cmplte">{ArrowCheck}</i>
                                                                                        <div className="pendingreferuserjourney-text">
                                                                                            <p><strong>Account Opening Started</strong></p>
                                                                                            <span>25 Jun 2025</span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="pendingreferuserjourney-group">
                                                                                    <div className="pendingreferuserjourney-panel">
                                                                                        <i className="pndgreferusrjourney-cmplte">{ArrowCheck}</i>
                                                                                        <div className="pendingreferuserjourney-text">
                                                                                            <p><strong>Details Submitted and Under Verification</strong></p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="pendingreferuserjourney-group">
                                                                                    <div className="pendingreferuserjourney-panel">
                                                                                        <i className="pndgreferusrjourney-cmplte">{ArrowCheck}</i>
                                                                                        <div className="pendingreferuserjourney-text">
                                                                                            <p><strong>Account Successfully Opened</strong></p>
                                                                                            <span>29 Jun 2025</span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="pendingrefer-group">
                                                                <div className="pendingreferuser-list">
                                                                    <div className="pendingreferuser-repeat">
                                                                        <div className="pendingreferuser-group">
                                                                            <div className="pendingreferuser-grid">
                                                                                <div className="pendingreferuser-panel">
                                                                                    <img src={avatar} alt="ravindra-yadav"></img>
                                                                                </div>
                                                                                <div className="pendingreferuser-text">
                                                                                    <h5>Kapil Awal</h5>
                                                                                    <div className="pendingreferuser-statusshare">
                                                                                        <div className="pendingreferuser-statuspanel">
                                                                                            <span className="pendingreferuser-completed incmpltepnduser">Incomplete</span>
                                                                                        </div>
                                                                                        <div className="pendingreferuser-share">
                                                                                            <a href="tel:1234561234"> <i>{Whatsapp}</i></a>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div onClick={() => ShowPendingUserJourney(2)} className="pendingreferuser-icon">
                                                                                {Pendingreferuserjorny ? AngleUp : AngleDown}
                                                                            </div>
                                                                        </div>
                                                                        {Pendingreferuserjorny &&
                                                                            <div className="pendingreferuserjourney-grid">
                                                                                <div className="pendingreferuserjourney-group">
                                                                                    <div className="pendingreferuserjourney-panel">
                                                                                        <i className="pndgreferusrjourney-cmplte">{ArrowCheck}</i>
                                                                                        <div className="pendingreferuserjourney-text">
                                                                                            <p><strong>Account Opening Started</strong></p>
                                                                                            <span>25 Jun 2025</span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="pendingreferuserjourney-group">
                                                                                    <div className="pendingreferuserjourney-panel">
                                                                                        <i className="pndgreferusrjourney-cmplte">{ArrowCheck}</i>
                                                                                        <div className="pendingreferuserjourney-text">
                                                                                            <p><strong>Details Submitted and Under Verification</strong></p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="pendingreferuserjourney-group">
                                                                                    <div className="pendingreferuserjourney-panel">
                                                                                        <i className="pndgreferusrjourney-cmplte incmplte">{Close}</i>
                                                                                        <div className="pendingreferuserjourney-text">
                                                                                            <p><strong>Account Successfully Opened</strong></p>

                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="pendingrefer-group">
                                                                <div className="pendingreferuser-list">
                                                                    <div className="pendingreferuser-repeat">
                                                                        <div className="pendingreferuser-group">
                                                                            <div className="pendingreferuser-grid">
                                                                                <div className="pendingreferuser-panel">
                                                                                    <img src={avatar} alt="ravindra-yadav"></img>
                                                                                </div>
                                                                                <div className="pendingreferuser-text">
                                                                                    <h5>Ravindra Yadav</h5>
                                                                                    <div className="pendingreferuser-statusshare">
                                                                                        <div className="pendingreferuser-statuspanel">
                                                                                            <span className="pendingreferuser-completed incmpltepnduser">Incomplete</span>
                                                                                        </div>
                                                                                        <div className="pendingreferuser-share">
                                                                                            <a href="tel:1234561234"> <i>{Whatsapp}</i></a>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div onClick={() => ShowPendingUserJourney(1)} className="pendingreferuser-icon">
                                                                                {Pendingreferuserjorny ? AngleUp : AngleDown}
                                                                            </div>
                                                                        </div>
                                                                        {Pendingreferuserjorny &&
                                                                            <div className="pendingreferuserjourney-grid">
                                                                                <div className="pendingreferuserjourney-group">
                                                                                    <div className="pendingreferuserjourney-panel">
                                                                                        <i className="pndgreferusrjourney-cmplte">{ArrowCheck}</i>
                                                                                        <div className="pendingreferuserjourney-text">
                                                                                            <p><strong>Account Opening Started</strong></p>
                                                                                            <span>25 Jun 2025</span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="pendingreferuserjourney-group">
                                                                                    <div className="pendingreferuserjourney-panel">
                                                                                        <i className="pndgreferusrjourney-cmplte incmplte">{Close}</i>
                                                                                        <div className="pendingreferuserjourney-text">
                                                                                            <p><strong>Details Submitted and Under Verification</strong></p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="pendingreferuserjourney-group">
                                                                                    <div className="pendingreferuserjourney-panel">
                                                                                        <i className="pndgreferusrjourney-cmplte incmplte">{Close}</i>
                                                                                        <div className="pendingreferuserjourney-text">
                                                                                            <p><strong>Account Successfully Opened</strong></p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                } */}

                                                {PendingReferPopup &&
                                                    <div className="pendingrefer-popup">
                                                        <h4><span> Referrals Status</span></h4>
                                                        <p>Remind your friend to complete KYC and earn rewards</p>
                                                        <div className="pendingrefer-list">
                                                            {referralDetails.map((referral, index) => {
                                                                const user = referral.name;
                                                                const journey = referral.getDetails[0];
                                                                const {
                                                                    date_Opening_Started,
                                                                    account_Opening_Started,
                                                                    detail_Verification,
                                                                    account_Successfully_Opened,
                                                                    date_Account_Opened
                                                                } = journey;

                                                                const isCompleted = account_Successfully_Opened === "Yes";
                                                                const isVerified = detail_Verification === "Yes";

                                                                return (
                                                                    <div key={index} className="pendingrefer-group">
                                                                        <div className="pendingreferuser-list">
                                                                            <div className="pendingreferuser-repeat">
                                                                                <div className="pendingreferuser-group">
                                                                                    <div className="pendingreferuser-grid">
                                                                                        <div className="pendingreferuser-panel">
                                                                                            <img src={avatar} alt={user}></img>
                                                                                        </div>
                                                                                        <div className="pendingreferuser-text">
                                                                                            <h5>{user}</h5>
                                                                                            <div className="pendingreferuser-statusshare">
                                                                                                <div className="pendingreferuser-statuspanel">
                                                                                                    <span className={isCompleted ? "pendingreferuser-completed" : "pendingreferuser-inprogress"}>
                                                                                                        {isCompleted ? "Completed" : <span className="pendingreferuser-completed incmpltepnduser">Incomplete</span>}
                                                                                                    </span>
                                                                                                </div>
                                                                                                <div className="pendingreferuser-share">
                                                                                                    <a href="tel:1234561234"> <i>{Whatsapp}</i></a>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div onClick={() => ShowPendingUserJourney(index)} className="pendingreferuser-icon">
                                                                                        {Pendingreferuserjorny === index ? AngleUp : AngleDown}
                                                                                    </div>
                                                                                </div>

                                                                                {Pendingreferuserjorny === index && (
                                                                                    <div className="pendingreferuserjourney-grid">
                                                                                        <div className="pendingreferuserjourney-group">
                                                                                            <div className="pendingreferuserjourney-panel">
                                                                                                {/* Account Opening Started */}
                                                                                                <i className="pndgreferusrjourney-icon">
                                                                                                    {account_Opening_Started === "Yes" ? <i className="pndgreferusrjourney-cmplte">{ArrowCheck}</i> : <i className="pndgreferusrjourney-cmplte incmplte">{CloseCross}</i>}
                                                                                                </i>
                                                                                                <div className="pendingreferuserjourney-text">
                                                                                                    <p><strong>Account Opening Started</strong></p>
                                                                                                    <span>{formatDate(date_Opening_Started)}</span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className="pendingreferuserjourney-group">
                                                                                            <div className="pendingreferuserjourney-panel">
                                                                                                {/* Details Submitted and Under Verification */}
                                                                                                <i className="pndgreferusrjourney-icon">
                                                                                                    {detail_Verification === "Yes" ? <i className="pndgreferusrjourney-cmplte">{ArrowCheck}</i> : <i className="pndgreferusrjourney-cmplte incmplte">{CloseCross}</i>}
                                                                                                </i>
                                                                                                <div className="pendingreferuserjourney-text">
                                                                                                    <p><strong>Details Submitted and Under Verification</strong></p>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className="pendingreferuserjourney-group">
                                                                                            <div className="pendingreferuserjourney-panel">
                                                                                                {/* Account Successfully Opened */}
                                                                                                <i className="pndgreferusrjourney-icon">
                                                                                                    {account_Successfully_Opened === "Yes" ? <i className="pndgreferusrjourney-cmplte">{ArrowCheck}</i> : <i className="pndgreferusrjourney-cmplte incmplte">{CloseCross}</i>}
                                                                                                </i>
                                                                                                <div className="pendingreferuserjourney-text">
                                                                                                    <p><strong>Account Successfully Opened</strong></p>
                                                                                                    {date_Account_Opened && <span>{formatDate(date_Account_Opened)}</span>}
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                }

                                                {/* .........................Pending-Refer-Popup-End......................... */}

                                                <div className="rewardreferrPndg-termscondtn pt-3 text-left">
                                                    <p>*Please refer to our <a href="/ReferralProgramPolicy">Terms & Conditions</a></p>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            )}

                        </Container>
                    </section>

                </div>
                <section className="referBenefit-section">
                    <div className="container">
                        <div class="page_heading"><h2>Benefits of <strong className="referearnhead-color">Moneysukh Demat</strong> <span>account</span></h2></div>
                        <div className="referBenefitbox-grid">
                            <div className="referBenefitbox-group you">
                                <div className="referBenefitbox-panel">

                                    {/* alt="Arrow" */}
                                    <img className="ArrowYou" src={ArrowYou} alt="Arrow"></img>
                                    <span className="referBenefit-you">You</span>
                                    <h5>Earn ₹ 50 + 50% <br></br><a href="#">Brokerage Sharing*</a></h5>
                                    <p>Every time your Referred Friend<br></br> opens an Moneysukh<br></br> Demat account</p>
                                </div>
                            </div>
                            <div className="referBenefitbox-group referBenefitbox-img">
                                <div className="referBenefitbox-panel">
                                    <img src={ShareReferral} alt="referBenefit"></img>
                                </div>
                            </div>
                            <div className="referBenefitbox-group friend">
                                <div className="referBenefitbox-panel">

                                    {/* alt="Arrow" */}
                                    <img className="ArrowFriend" src={ArrowFriend} alt="Arrow"></img>
                                    <span className="referBenefit-you ">Friend</span>
                                    <h5>Zero brokerage on</h5>
                                    <p>Delivery, Free algo platform,<br></br> free research recommendations</p>
                                </div>
                            </div>
                        </div>
                        <p className="rewardreferr-notetermscondn"><strong>*Note:</strong> Please refer to our <a href="/ReferralProgramPolicy">Terms & Conditions</a></p>
                    </div>
                </section>

                <section className="howreferearn-section">
                    <div className="container">
                        <div class="page_heading"><h2>How<strong className="referearnhead-color"> Refer & Earn</strong>  <span>Works?</span></h2></div>
                        <div className="howreferearnbox-grid">
                            <div className="howreferearnbox-group">
                                <div className="howreferearnbox-panel">
                                    <div className="howreferearnbox-img">
                                        <span className="howreferearn-num">01</span>
                                        {/* alt="Refer Icon" */}
                                        <img src={howreferearnStep1} alt="Refer Icon"></img>
                                    </div>
                                    <h5>Step 1</h5>
                                    <p>Open an Moneysukh <br></br>Account</p>
                                </div>
                            </div>
                            <div className="howreferearnbox-group">
                                <div className="howreferearnbox-panel">
                                    <div className="howreferearnbox-img">
                                        <span className="howreferearn-num">02</span>
                                        {/* alt="Refer Icon" */}
                                        <img src={howreferearnStep2} alt="Refer Icon"></img>
                                    </div>
                                    <h5>Step 2</h5>
                                    <p>Refer friends and loved<br></br> ones to Moneysukh</p>
                                </div>
                            </div>
                            <div className="howreferearnbox-group">
                                <div className="howreferearnbox-panel">
                                    <div className="howreferearnbox-img">
                                        <span className="howreferearn-num">03</span>
                                        {/* alt="Refer Icon" */}
                                        <img src={howreferearnStep3} alt="Refer Icon"></img>
                                    </div>
                                    <h5>Step 3</h5>
                                    <p>Earn <strong>₹ 50 + 50%</strong> <br></br> Brokerage Sharing*<br></br>
                                        <small>*Please refer to our <a href="/ReferralProgramPolicy" className="referLink">Terms & Conditions</a></small>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="friendsget-section">
                    <div className="container">
                        <div class="page_heading"><h2>What Your <strong className="referearnhead-color">Friends</strong> <span>Get?</span></h2>
                            <p><strong>Note:</strong> Referrals are valid only if the referred individual is not already listed as <br></br>
                                an existing or potential client in the Moneysukh database
                            </p>
                        </div>
                        <div className="friendsgetbox-grid">
                            <div className="friendsgetbox-group">
                                <div className="friendsgetbox-panel">
                                    <h5>Free</h5>
                                    <p>Account <br></br>Opening</p>
                                </div>
                            </div>
                            <div className="friendsgetbox-group">
                                <div className="friendsgetbox-panel">
                                    <h5>₹ 0</h5>
                                    <p>Annual Maintenance Charge</p>
                                </div>
                            </div>
                            <div className="friendsgetbox-group">
                                <div className="friendsgetbox-panel">
                                    <h5>₹ 10<small>/</small>Order</h5>
                                    <p>Brokerage</p>
                                </div>
                            </div>
                            <div className="friendsgetbox-group">
                                <div className="friendsgetbox-panel">
                                    <h5>Free</h5>
                                    <p>Algo platform, research recommendations</p>
                                </div>
                            </div>
                        </div>
                        <div className="refernow-btnpanel text-center">
                            <span onClick={ShowreReferpopup} className="refernow-btn"><span>Refer Now!</span><i>{ArrowRight}</i></span>
                            <p><a href="/ReferralProgramPolicy">Terms & Conditions</a></p>
                        </div>
                    </div>
                </section>
                <section className="referearnTrust-section">
                    <div className="referearnTrust-main">
                        <div className="container">
                            <div class="page_heading"><h2>Why Customer Trust <span> Us</span></h2>
                                <p>We have a large network of branches and Authorized Persons <br></br>in over 300 locations across India</p>
                            </div>
                            <div className="referearnTrustbox-grid">
                                <div className="referearnTrustbox-group">
                                    <div className="referearnTrustbox-panel">
                                        <div className="referearnTrustbox-img">
                                            {/* alt="Trust Icon" */}
                                            <img src={referearntrust} alt="Trust Icon"></img>
                                        </div>
                                        <div className="referearnTrustbox-cont">
                                            <h5>33+</h5>
                                            <p>Years of Trust</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="referearnTrustbox-group">
                                    <div className="referearnTrustbox-panel">
                                        <div className="referearnTrustbox-img">
                                            {/* alt="Trust Icon" */}
                                            <img src={referearnCloud} alt="Cloud Icon"></img>
                                        </div>
                                        <div className="referearnTrustbox-cont">
                                            <h5>Cloud</h5>
                                            <p>Cloud based server</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="referearnTrustbox-group">
                                    <div className="referearnTrustbox-panel">
                                        <div className="referearnTrustbox-img">
                                            {/* alt="Secure Icon" */}
                                            <img src={referearnSecure} alt="Secure Icon"></img>
                                        </div>
                                        <div className="referearnTrustbox-cont">
                                            <h5>Secure</h5>
                                            <p>Zero Downtime</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div>

                {/* <Container>
                    <Modal show={modelshow} onHide={handleClose} backdrop="static" keyboard={false} className="referearnnew-popup" >
                        <Modal.Body>
                            <div className="referearnnew-popupbody">
                                <h1>Refer Friends to Earn Rewards!</h1>
                                <form class="referearnnew_form">
                                    <div className="referearnnew-leftrightgrid">
                                        <div class="referearnnew-popupleft">
                                            <h4 className="text-left">You</h4>
                                            <div class="form-group">
                                                <input type="text" class="form-control" id="ClientId" placeholder="Client Id" />
                                            </div>
                                            <div class="form-group">
                                                <input type="text" class="form-control" id="yourname" placeholder="Name" />
                                            </div>
                                            <div class="form-group">
                                                <input type="number" class="form-control" id="yournumber" placeholder="Mobile No" />
                                            </div>

                                        </div>
                                        <div className="referearnnew-popupright">
                                            <h4 className="text-left">Friends</h4>
                                            <span className="closeBtn" onClick={handleClose}>
                                                {ClosePopup}
                                            </span>

                                            <div class="form-group">
                                                <input type="email" class="form-control" id="ClientId" placeholder=" Name" />
                                            </div>
                                            <div class="form-group">
                                                <input type="number" class="form-control" id="yournumber" placeholder="Mobile No" />
                                            </div>
                                            <div class="form-group">
                                                <input type="number" class="form-control" id="yournumber" placeholder="3+2=?" />
                                            </div>


                                        </div>
                                    </div>
                                    <button class="btn refernow-popup"><span>Submit</span>  
                                    </button>
                                </form>
                            </div>
                        </Modal.Body>
                    </Modal>
                </Container> */}
            </div>
        </>
    )
}

export default ReferEarnNew;